<template>
  <TabPanels :unstyled="true" :pt="passThrough" class="meridia-tab-panels" v-bind="$attrs">
    <div class="meridia-tab-panels-inner flex flex-col flex-1 overflow-hidden">
      <slot />
    </div>
  </TabPanels>
</template>

<script setup lang="ts">
import { computed, provide, toRef } from 'vue';
import TabPanels from 'primevue/tabpanels';
import { usePassThrough } from 'primevue/passthrough';
import type { PassThrough } from '@primevue/core';
import type { TabPanelsPassThroughOptions } from 'primevue/tabpanels';
import type { MeridiaTabPanelsProps } from 'src/design_system/components/tab/types';

const props = withDefaults(
  defineProps<MeridiaTabPanelsProps>(),
  {
    animated: false,
    keepAlive: false,
  }
);

provide('meridiaTabPanelsKeepAlive', toRef(props, 'keepAlive'));
provide('meridiaTabPanelsAnimated', toRef(props, 'animated'));

const defaultPt: TabPanelsPassThroughOptions = {
  root: {
    class: 'meridia-tab-panels-root flex flex-col flex-1 overflow-hidden w-full min-h-0',
  },
};

const passThrough = computed(() =>
  usePassThrough(
    props.pt,
    defaultPt,
    { mergeSections: false, mergeProps: true }
  ) as PassThrough<TabPanelsPassThroughOptions>
);
</script>

